import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { PosService } from "src/app/core/services/pos.service";
import { CheckPrintRequest } from "../../models/CheckPrintRequest.model";
import { AppMessageSeverity } from "../../models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-pos-print-printer-select",
	templateUrl: "./pos-print-printer-select.component.html",
	styleUrls: ["../../../modules/online-order/online-order.component.scss"],
})
export class PosPrintPrinterSelectComponent implements OnInit {
	@Output() closeDialogChange = new EventEmitter<boolean>();
	@Input() checkKey: string;
	@Input() checkNumber: number;
	@Input() seatKey: number;

	displayDialog: boolean = true;

	printerSelection: {
		label: string;
		value: number;
	}[];

	printerSelected: { label: string; value: number };

	constructor(public posService: PosService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		if (!this.posService.posConfigurationMenu.value?.venueKey) {
			if (this.posService.venueService.venueKey) {
				this.posService.posMenuGet();
				this.posService.posConfigurationMenu.subscribe((data) => {
					this.printerSelection = data.stations.map((station) => {
						console.log("set printers");
						return { label: station.name, value: station.id };
					});
				});
			}
		}
	}

	async onPrintAction() {
		const ooMenuConfig = await this.focuslink.getOOMenuConfig(this.posService.venueService.venueKey);
		await this.focuslink.checkPrint(
			this.posService.venueService.venueKey,
			this.checkKey,
			new CheckPrintRequest({
				employeeId: ooMenuConfig.employeeRecNum,
				stationId: this.printerSelected.value,
				combine: false,
				seatNumber: this.seatKey,
			})
		);
		this.posService.venueService.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Check printed` });
		this.closeDialogChange.emit(true);
	}
}
